/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTemperaturePlus: {
  name: 'temperature-plus';
  data: string;
} = {
  name: 'temperature-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 1a.5.5 0 0 0-1 0v1.5H3a.5.5 0 0 0 0 1h1.5V5a.5.5 0 0 0 1 0V3.5H7a.5.5 0 0 0 0-1H5.5V1Zm4.5.5a.5.5 0 0 0-.5.5v7a.503.503 0 0 1-.007.085.5.5 0 0 1-.326.556A2.501 2.501 0 0 0 10 14.5a2.5 2.5 0 0 0 .833-4.858.5.5 0 0 1-.326-.556A.506.506 0 0 1 10.5 9V2a.5.5 0 0 0-.5-.5Zm1.5 7.336V2a1.5 1.5 0 0 0-3 0v6.836a3.5 3.5 0 1 0 3 0Z" fill="currentColor"/></svg>`,
};
